<template>
  <div>
    <div class="vx-row">
      <h2 class="p-3 mb-3">Dolgotrajno parkiranje</h2>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card>

          <div class="vx-row">

            <div class="vx-col sm">
              <b>Obdobje: </b>
            </div>

            <div class="vx-col sm">
              <datepicker
                @input="loadData()"
                :format="dateFormat"
                :disabledDates="disabledDates"
                :minimumView="'month'"
                :maximumView="'year'"
                v-model="dateFrom"
              ></datepicker>
            </div>

          </div>

        </vx-card>
      </div>
    </div>

    <vx-card>
      <div class="flex text-center mt-4 p-4 my-auto"
           slot="no-body-bottom">
        <div class="w-3/4 sm:w-1/1">
          <p>
            Število trajno najetih parkirnih mest v mesecu
          </p>
        </div>
        <div class="w-1/4 my-auto sm:w-1/1">
          <p class="font-semibold">{{steviloTrajnoNajetihMest}}</p>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <div class="flex text-center mt-4 p-4 my-auto"
           slot="no-body-bottom">
        <div class="w-3/4 sm:w-1/1">
          <p>
            Število prodanih mesečnih kartončkov na blagajni
          </p>
        </div>
        <div class="w-1/4 my-auto sm:w-1/1">
          <p class="font-semibold">{{steviloProdanihNaBlagajni}}</p>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <div class="flex text-center mt-4 p-4 my-auto"
           slot="no-body-bottom">
        <div class="w-3/4 sm:w-1/1">
          <p>
            Povprečna vrednost/cena dolgotrajnega parkiranja na posamezno parkirno mesto
          </p>
        </div>
        <div class="w-1/4 my-auto sm:w-1/1">
          <p class="font-semibold">{{povprecnaVrednostInEur}} </p>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <div class="flex text-center mt-4 p-4 my-auto"
           slot="no-body-bottom">
        <div class="w-3/4 sm:w-1/1">
          <p>
            Skupna vrednost dolgotrajnega parkiranja
          </p>
        </div>
        <div class="w-1/4 my-auto sm:w-1/1">
          <p class="font-semibold">{{skupnaVrednostInEur}} </p>
        </div>
      </div>
    </vx-card>
    <!--    -->
    <!--    <vx-card class="flex text-center mt-4 p-4 my-auto">-->
    <!--      <div class="flex text-center mt-4 p-4 my-auto">-->
    <!--        <div class="w-1/3 mr-5">-->
    <!--          <Chart-->
    <!--            type="bar"-->
    <!--            height="350"-->
    <!--            width="100"-->
    <!--            :display-number-picker="false"-->
    <!--            :series="series"-->
    <!--            title="Statistika dologotrajnega parkiranja"-->
    <!--            :options="barChart.chartOptionsOne"-->
    <!--          ></Chart>-->
    <!--        </div>-->
    <!--        <div class="w-1/3 mr-5">-->
    <!--          <Chart-->
    <!--            type="bar"-->
    <!--            height="350"-->
    <!--            width="100"-->
    <!--            :display-number-picker="false"-->
    <!--            :series="seriesTwo"-->
    <!--            title="Povprečna vrednost/cena dolgotrajnega parkiranja na posamezno parkirno mesto"-->
    <!--            :options="barChart.chartOptionsTwo"-->
    <!--          ></Chart>-->
    <!--        </div>-->
    <!--        <div class="w-1/3">-->
    <!--          <Chart-->
    <!--            type="bar"-->
    <!--            height="350"-->
    <!--            width="100"-->
    <!--            :display-number-picker="false"-->
    <!--            :series="seriesThree"-->
    <!--            title="Skupna vrednost dolgotrajnega parkiranja"-->
    <!--            :options="barChart.chartOptionsThree"-->
    <!--          ></Chart>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </vx-card>-->

  </div>
</template>

<script>

  import VueApexCharts from 'vue-apexcharts'
  import Chart from '../charts/Chart'
  import Datepicker from 'vuejs-datepicker'

  export default {
    components: {
      VueApexCharts,
      Chart,
      Datepicker
    },

    data () {
      return {

        dateFrom: new Date(),

        dateFormat: 'MMMM yyyy',

        disabledDates: {
          to: new Date(new Date().getFullYear() - 10, new Date().getMonth(), new Date().getDay()), // Disable all dates up to specific date
          from: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDay()) // Disable all dates after specific date
        },

        steviloTrajnoNajetihMest: 0,
        steviloProdanihNaBlagajni: 0,
        povprecnaVrednost: 0,
        skupnaVrednost: 0,

        povprecnaVrednostInEur: 0,
        skupnaVrednostInEur: 0,

        dateObject: {
          dateFrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          dateTo: new Date(
            new Date().getFullYear(),
            new Date().getMonth() + 1,
            0
          )
        },

        barChart: {
          chartOptionsOne: {
            chart: {
              height: 350,
              width: 1000,
              animations: {
                enabled: true
              }
            },
            xaxis: {
              categories: ['Trajno najeta mesta', 'Prodano na blagajni'],
              position: 'top',
              axisTicks: {
                show: false
              },
              crosshairs: {
                fill: {
                  type: 'gradient',
                  gradient: {
                    colorFrom: '#D8E3F0',
                    colorTo: '#BED1E6',
                    stops: [0, 100],
                    opacityFrom: 0.4,
                    opacityTo: 0.5
                  }
                }
              },
              tooltip: {
                enabled: true
              }
            }
          },
          chartOptionsTwo: {
            chart: {
              height: 1000,
              width: 1000,
              animations: {
                enabled: true
              }
            },
            xaxis: {
              categories: ['Povprečna vrednost'],
              position: 'top',
              axisTicks: {
                show: false
              },
              crosshairs: {
                fill: {
                  type: 'gradient',
                  gradient: {
                    colorFrom: '#D8E3F0',
                    colorTo: '#BED1E6',
                    stops: [0, 100],
                    opacityFrom: 0.4,
                    opacityTo: 0.5
                  }
                }
              },
              tooltip: {
                enabled: true
              }
            }
          },
          chartOptionsThree: {
            chart: {
              height: 1000,
              width: 1000,
              animations: {
                enabled: true
              }
            },
            xaxis: {
              categories: ['Skupna vrednost'],
              position: 'top',
              axisTicks: {
                show: false
              },
              crosshairs: {
                fill: {
                  type: 'gradient',
                  gradient: {
                    colorFrom: '#D8E3F0',
                    colorTo: '#BED1E6',
                    stops: [0, 100],
                    opacityFrom: 0.4,
                    opacityTo: 0.5
                  }
                }
              },
              tooltip: {
                enabled: true
              }
            }
          }
        },

        yaxis: {
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          labels: {
            show: false,
            formatter: function (val) {
              return val + '%'
            }
          }
        }
      }
    },

    methods: {
      setPricesInEur () {
        this.povprecnaVrednostInEur = new Intl.NumberFormat('de-DE', {
          style: 'currency',
          minimumFractionDigits: 2,
          currency: 'EUR'
        }).format(this.povprecnaVrednost)

        this.skupnaVrednostInEur = new Intl.NumberFormat('de-DE', {
          style: 'currency',
          minimumFractionDigits: 2,
          currency: 'EUR'
        }).format(this.skupnaVrednost)
      },
      async loadData () {

        var date = this.dateFrom, y = date.getFullYear(), m = date.getMonth()
        var firstDay = new Date(y, m, 1)
        var lastDay = new Date(y, m + 1, 0)

        if (date < lastDay && date.getMonth() == (new Date().getMonth())) {
          lastDay = new Date()
        }

        let payload = {
          dateFrom: await this.$moment(firstDay).format(
            'YYYY-MM-DD'),
          dateTo: await this.$moment(lastDay).format(
            'YYYY-MM-DD'
          )
        }

        let response = await this.$store.dispatch('data/fetchLongParkingData', payload)
        this.prepareData(response.data)

        this.setPricesInEur()
      },

      async handleSearchClicked () {
        await this.loadData()
      },
      prepareData (data) {
        let date = new Date()
        let numberOfDaysInMonth = new Date(
          date.getFullYear(),
          date.getMonth(),
          0
        ).getDate()

        this.steviloTrajnoNajetihMest = data.stevilo_trajno_najetih_mest
        this.steviloProdanihNaBlagajni = data.stevilo_prodanih_na_blagajni
        this.povprecnaVrednost = data.povprecna_vrednost
        this.skupnaVrednost = data.skupna_vrednost
      }
    },
    computed: {
      data () {
        return this.$store.state.data.xmlData.slice()
      },
      series () {
        return [
          {
            name: '',
            data: [this.steviloTrajnoNajetihMest, this.steviloProdanihNaBlagajni]
          }
        ]
      },
      seriesTwo () {
        return [
          {
            name: '',
            data: [this.povprecnaVrednost]
          }
        ]
      },
      seriesThree () {
        return [
          {
            name: '',
            data: [this.skupnaVrednost]
          }
        ]
      }
    },
    async mounted () {
      this.$vs.loading()
      try {
        await this.loadData()
      } catch (error) {
        this.$vs.notify({
          title: 'Napaka pri nalaganju podatkov!',
          text: error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      } finally {
        this.$vs.loading.close()
      }
    }
  }
</script>
